/**
 * Sentry's `beforeBreadcrumb`: a navigation breadcrumb keeps the path and loses the query and the
 * fragment, where a one-time code or a provider's session id can ride. Pure.
 */

import type { Breadcrumb } from '@sentry/react';

function pathOnly(value: unknown): unknown {
  return typeof value === 'string' ? value.replace(/[?#].*$/s, '') : value;
}

export function scrubBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb {
  if (breadcrumb.category !== 'navigation' || breadcrumb.data === undefined) return breadcrumb;
  return {
    ...breadcrumb,
    data: { ...breadcrumb.data, from: pathOnly(breadcrumb.data.from), to: pathOnly(breadcrumb.data.to) },
  };
}
